import React, { useMemo, useState, useCallback } from "react";
import { useReport } from "../../hooks/useReport";
import './report.css';

export default function Report({ toggleReporting, getNextMovie, imdb_id, trailer }) {

    const options = useMemo(() => ([
        "TRAILER DID NOT LOAD",
        "TRAILER IS INCORRECT",
        "TRAILER IS BAD QUALITY",
    ]), []);

    const [selected, setSelected] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const { onReport } = useReport();


    const stopPropagation = (e) => {
        e.stopPropagation();
        e.preventDefault();
    }

    const onSelect = useCallback((value) => {
        setSelected(prev => prev === value ? null : value);
    }, []);

    const onSubmit = useCallback(async () => {
        if (!selected || !imdb_id || !trailer || submitting) return;
        setSubmitting(true);
        try {
            await onReport(imdb_id, trailer, selected);
        } catch (e) {
            // no-op
        } finally {
            setSubmitting(false);
            toggleReporting();
            getNextMovie();
        }
    }, [selected, imdb_id, trailer, submitting, toggleReporting, getNextMovie, onReport]);

    return (
        <div onClick={stopPropagation} onMouseDown={stopPropagation} className="report">
            <div className={"report-inner"}>
                <p className={"report-title"}>REPORT TRAILER</p>
                <div className={"report-options"}>
                    {options.map((opt) => (
                        <button
                            key={opt}
                            onClick={() => onSelect(opt)}
                            onMouseDown={stopPropagation}
                            className={`btn-report ${selected === opt ? 'btn-report-clicked' : ''}`}
                            style={{
                                width: '100%',
                                margin: '0.35rem 0',
                                height: '52px',
                                padding: '3px 0.75rem 0',
                                position: 'relative',
                                color: 'white'
                            }}
                        >
                            <span style={{
                                position: 'static',
                                transform: 'none',
                                fontFamily: 'Josefin Sans',
                                fontWeight: 600,
                                letterSpacing: '0.2rem',
                                fontSize: '0.7rem',
                                color: selected === opt ? "black" : "white"
                            }}>{opt}</span>
                        </button>
                    ))}
                </div>
                {selected ? (
                    <div className={"report-submit-container"}>
                        <p className={"report-submit"} onClick={onSubmit} onMouseDown={stopPropagation}>{submitting ? 'SUBMITTING…' : 'SUBMIT'}</p>
                    </div>
                ) : null}
            </div>
        </div>
    )
}
